// src/components/TaskOriginBadge.jsx
import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import "./TaskOriginBadge.css"; // Você precisa criar este arquivo

export default function TaskOriginBadge({ notaId }) {
  const [originInfo, setOriginInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!notaId) return;
    
    const buscarOrigemObjetivo = async () => {
      setLoading(true);
      try {
        // ── Buscar vínculo na tabela de relacionamento ──
        const { data: vinculo } = await supabase
          .from("ata_objetivos_notas_vinculadas")
          .select("ata_objetivo_id, criado_por")
          .eq("nota_id", notaId)
          .single();

        if (!vinculo) {
          setOriginInfo(null);
          setLoading(false);
          return;
        }

        // ── Buscar objetivo ──
        const { data: objetivo } = await supabase
          .from("ata_objetivos")
          .select("id, texto, ata_id")
          .eq("id", vinculo.ata_objetivo_id)
          .single();

        if (!objetivo) {
          setOriginInfo(null);
          setLoading(false);
          return;
        }

        // ── Buscar ata ──
        const { data: ata } = await supabase
          .from("atas")
          .select("nota_id")
          .eq("id", objetivo.ata_id)
          .single();

        let ataNome = "Ata";
        if (ata?.nota_id) {
          const { data: notaAta } = await supabase
            .from("notas")
            .select("nome")
            .eq("id", ata.nota_id)
            .single();
          ataNome = notaAta?.nome || "Ata";
        }

        // ── Buscar responsáveis do objetivo ──
        const { data: responsaveis } = await supabase
          .from("ata_objetivos_responsaveis_enriquecidos")
          .select("nome_exibicao, usuario_id")
          .eq("ata_objetivo_id", vinculo.ata_objetivo_id);

        const nomesCriador = await supabase
          .from("profiles")
          .select("nome, nickname")
          .eq("id", vinculo.criado_por)
          .single();

        setOriginInfo({
          objetivoTexto: objetivo.texto,
          ataNome: ataNome,
          responsaveis: (responsaveis || []).map(r => r.nome_exibicao).join(", ") || "Sem responsáveis",
          criadorNome: nomesCriador.data?.nickname || nomesCriador.data?.nome || "Usuário"
        });
      } catch (err) {
        console.error("Erro ao buscar origem do objetivo:", err);
        setOriginInfo(null);
      } finally {
        setLoading(false);
      }
    };

    buscarOrigemObjetivo();
  }, [notaId]);

  if (loading || !originInfo) return null;

  return (
    <div className="task-origin-badge">
      <div className="task-origin-badge-header">
        <span className="task-origin-badge-icon">📌</span>
        <span className="task-origin-badge-label">Criado a partir de objetivo</span>
      </div>
      
      <div className="task-origin-badge-content">
        <div className="task-origin-badge-row">
          <span className="task-origin-badge-field">Ata:</span>
          <strong>{originInfo.ataNome}</strong>
        </div>
        
        <div className="task-origin-badge-row">
          <span className="task-origin-badge-field">Objetivo:</span>
          <span className="task-origin-badge-objetivo">{originInfo.objetivoTexto}</span>
        </div>
        
        {originInfo.responsaveis && (
          <div className="task-origin-badge-row">
            <span className="task-origin-badge-field">Responsáveis:</span>
            <span>{originInfo.responsaveis}</span>
          </div>
        )}
        
        <div className="task-origin-badge-row">
          <span className="task-origin-badge-field">Criado por:</span>
          <span>{originInfo.criadorNome}</span>
        </div>
      </div>
    </div>
  );
}